import { useState } from "react";
import { Button, useToast } from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";

export default function PrintAllReadyButton({ businessId }) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handlePrintAll = async () => {
    if (!businessId) return;

    setLoading(true);
    const now = new Date().toISOString();

    const { error } = await supabase
      .from("dispatch_queue")
      .update({ scheduled_print_at: now })
      .eq("business_id", businessId)
      .is("scheduled_print_at", null);

    setLoading(false);

    if (error) {
      toast({
        title: "Print Failed",
        description: error.message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Print Scheduled",
        description: "All ready sectors scheduled for print.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Button
      size="sm"
      colorScheme="green"
      onClick={handlePrintAll}
      isLoading={loading}
    >
      Print All Ready
    </Button>
  );
}
